import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_7'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_7',
  name: "Which of the following topics are included within the facility's written policies and procedures for discipline?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FACILITY_RULES_CONCERNING_DISCIPLINE',
      text: 'Facility rules concerning discipline',
      externalIds: [
        {
          id: 'ms-1--9-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKER_APPEALS_PROCESS',
      text: 'Worker appeals process',
      externalIds: [
        {
          id: 'ms-1--9-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKER_GRIEVANCE_PROCESS',
      text: 'Worker grievance process',
      externalIds: [
        {
          id: 'ms-1--9-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--9-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--9-4f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FACILITY_RULES_CONCERNING_DISCIPLINE',
                'WORKER_APPEALS_PROCESS',
                'WORKER_GRIEVANCE_PROCESS',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-22',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 19540,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
